import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Form } from "react-bootstrap";
import { SubscriptionPeriodArr } from "../../../../hooks/utils";

const Donut3DChart = ({ data, name }) => {

    const graphData = data?.map(item => ({
        name: item?.[name] ?? name,
        y: item?.hits
    }));

    const donutChartOptions = {
        colors: ['#a1c1e0', '#C1C1C1', '#AD6ca5', '#787878', '#701540'],
        chart: {
            type: 'pie',
            options3d: {
                enabled: true,
                alpha: 45, // Tilt
                beta: 0,   // Rotation
                depth: 50, // Depth of the chart
            },
        },
        title: {
            text: '',
        },
        tooltip: {
            pointFormat: '{point.y} Visits ({point.percentage:.1f}%)',
        },
        plotOptions: {
            pie: {
                innerSize: 100,
                depth: 45,
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        // Only show label if percentage is >= 10%
                        if (this.percentage >= 10) {
                            return `${this.point.name}<br/>${this.percentage.toFixed(1)}%`;
                        }
                        return null; // Hide label for < 10%
                    },
                },
            },
        },
        series: [
            {
                name: name,
                data: graphData,
            },
        ],
    };

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={donutChartOptions} />
        </>
    )
}
export default Donut3DChart